import { cn } from 'src/shared/utils/cn'

import ProfileAvatarURL from './profile-avatar-url'

interface MultiProfilePhotoProps {
  profilePhotos?: (string | null)[]
  spacing?: number
  photoClassName?: string
  className?: string
  size?: number
}

export default function MultiProfilePhoto({
  profilePhotos,
  size = 65,
  photoClassName,
  className,
}: MultiProfilePhotoProps) {
  const filteredProfilePhotos = profilePhotos?.filter((photo) => photo) || []

  if (filteredProfilePhotos.length === 0) {
    return (
      <ProfileAvatarURL
        photoUrl={undefined}
        size={size}
        className={cn(
          'border-[3px] border-white shadow-[0_1px_12px_1px_rgba(27,48,41,0.1)]',
          className,
          photoClassName,
        )}
      />
    )
  }

  return (
    <div className="flex flex-row">
      {filteredProfilePhotos.map((photo, index) => (
        <div key={index} style={{ marginLeft: index !== 0 ? -size / 2 : 0 }}>
          <ProfileAvatarURL
            photoUrl={photo ?? undefined}
            size={size}
            className={cn(
              'border-[3px] border-white shadow-[0_1px_12px_1px_rgba(27,48,41,0.1)]',
              className,
              photoClassName,
            )}
          />
        </div>
      ))}
    </div>
  )
}
